<script>
    export let value;
</script>

{#if value}
    <div class="content tag_group">
        {#each value as reference}
            <div class="control">
                <div class="tags has-addons">
                    <span class="tag is-dark">{reference.framework}</span>
                    <span class="tag is-info">
                        {reference.control}
                    </span>
                </div>
            </div>
        {/each}
    </div>
{/if}